import modulePackage from "moment"

export const moment = modulePackage
